<template>
	<div class="study">
		<publicHeader @child-event="myInfoEvent"></publicHeader>
		<studyHeader :subjectIndex="subjectIndex" :studyNav="studyNav" :myInfo="myInfo" :public="public"></studyHeader>
		<div class="special_nav w1200 tc cl_gray">
			<span class="special_nav_list bg_gray" v-for="(item,index) in grade" :key="index" :class="{'on':grade_cur.id==item.id}" @click="gradeCheck(index)">{{item.name}}</span>
		</div>
		<div class="swiper-container special_banner">
		    <div class="swiper-wrapper">
		        <div class="swiper-slide" v-for="(item,index) in banner" :key="index">
							<router-link :to="item.jump_url" class="block"><img :src="item.pic" class="block radius8" /></router-link>
						</div>
		    </div>
		    <div class="swiper-pagination"></div>
		</div>
		<div class="special" v-if="list.length > 0">
			<div class="special_list" v-for="(item,index) in list" :key="index">
				<div class="special_list_date cl_gray f26px">
					<p>{{item.add_time}}</p>
				</div>
				<div class="special_list_cont">
					<router-link :to="{ path: '/special_details', query: { id: item.id }}">
						<p class="f18px clip">{{item.name}}</p>
						<img :src="item.pic" class="block radius8 mat5" />
					</router-link>
				</div>
			</div>
			<div class="special_btm cl_white radius">
				<div class="special_btm_div radius">新起点</div>
			</div>
		</div>
		<div class="choice_empty tc f18px cl_gray" v-if="list.length == 0">
			<p>找不到内容，请重新选择分类</p>
		</div>
		<vfooter @child-event="publicEvent"></vfooter>
	</div>
</template>

<script>
	import publicHeader from '../../components/header.vue'
	import studyHeader from '../../components/study_header.vue'
	import vfooter from '../../components/footer.vue'
	import '@/assets/js/swiper.min.js'
	import '@/assets/css/swiper.min.css'
	export default {
	  name: 'famous',
		components: {
			publicHeader,
			studyHeader,
			vfooter,
		},
	  props: {
	    
	  },
		data () {
			return {
				subjectIndex: false, //学科分类显示
				studyNav: 4,
				myInfo: {},
				public: {},
				grade: [], //年级
				grade_cur: {},
				banner: [], //轮播图
				list: [],
			}
		},
		mounted() {
			this.getGrade();
			this.getBanner();
		},
		created() {
			
		},
		methods: {
			myInfoEvent (data) {
				this.myInfo = data;
			},
			publicEvent (data) {
				this.public = data;
			},
			getBanner () {
				this.$get("/api/base/get_banner_data",{
					page_name: "study_topic_banner_cate_id",
				})
				.then(res => {
					this.banner = res.data;
					//轮播图
					var mySwiper = new Swiper('.special_banner', {
						autoplay: {
							disableOnInteraction: false,
						},
						pagination: {
							el: '.swiper-pagination',
							clickable :true,
						},
						observer:true,
						observeParents:true,
					});
				});
			},
			//年级
			getGrade () {
				this.$get("/api/article/get_study_topic_cate_data",{})
				.then(res => {
					this.grade = res.data;
					this.grade_cur = this.grade[0];
					this.getList();
				});
			},
			getList () {
				this.$get("/api/article/gtet_study_topic_article_data",{
					cate_id: this.grade_cur.id
				})
				.then(res => {
					this.list = res.data;
				});
			},
			
			gradeCheck (e) {
				this.grade_cur = this.grade[e];
				this.getList();
			},
		},
	}
</script>

<style>
</style>
